<template>
  <div class="probes">
    <div class="p-1 bg-black rounded" name="header" style="height:675px;">
        <!-- Header -->
        <div class="row">
            <div class="col-md-3">
                <p v-if="mode=='default'" class="fs-2 fw-light text-white text-center mt-2 ms-2" style="letter-spacing: 10px;">Probes</p>
                <p v-if="mode=='addition'" class="fs-2 fw-light text-white text-center mt-2 ms-2" style="letter-spacing: 10px;">New Probe</p>
            </div>
            <div v-if="mode=='default'" class="col-md-6">
               <div>
                    <div class="input-group flex-nowrap mt-2">
                        <input class="btn fw-light bg-synapse-glass text-white fs-4 w-100 me-1" type="text" style="cursor: default;" placeholder="Filter by keyword" v-model="searchWord">
                        <button class="btn rounded fs-4 me-1" :class="{'bg-synapse-glass text-white': searchType!='name', 'btn-synapse-dark': searchType=='name'}" @click="setSearchType('name')" title="Filter by Name">
                            <i class="fa-solid fa-desktop"></i>
                        </button>
                        <button class="btn rounded fs-4 me-1" :class="{'bg-synapse-glass text-white': searchType!='alias', 'btn-synapse-dark': searchType=='alias'}" @click="setSearchType('alias')" title="Filter by Alias">
                            <i class="fa-solid fa-id-badge"></i>
                        </button>
                        <button class="btn rounded fs-4 me-1" :class="{'bg-synapse-glass text-white': searchType!='type', 'btn-synapse-dark': searchType=='type'}" @click="setSearchType('type')" title="Filter by Type">
                            <i class="fa-solid fa-cubes"></i>
                        </button>
                        <button class="btn rounded fs-4 me-1" :class="{'bg-synapse-glass text-white': searchType!='category', 'btn-synapse-dark': searchType=='category'}" @click="setSearchType('category')" title="Filter by Category">
                            <i class="fa-solid fa-cube"></i>
                        </button>
                    </div>
               </div>
            </div>
            <div v-if="mode=='addition'" class="col-md-5"></div>
            <div class="col-md-1">
            </div>
            <!-- Notificators -->
            <div v-if="mode=='addition'" class="col-md-1">
                <div class="">
                    <button v-show="mode=='addition'" class="btn btn-synapse-dark text-white fs-4 w-100 mt-2" @click="clearAddition(null)">
                        <i class="fa-solid fa-xl fa-broom"></i>
                    </button>
                </div>
                <button v-if="false" v-show="mode=='addition'" class="btn btn-synapse-dark text-white fs-4 w-100 mt-2" data-bs-toggle="modal" data-bs-target="#manage-notificators" :disabled="gettingNotificators">
                    <i class="fa-solid fa-xl fa-bell fs-3" :class="{'fa-shake': gettingNotificators}"></i>
                </button>
            </div>
            <div class="col-md-1">
                <div class="">
                    <button v-show="mode=='default'" class="btn btn-synapse-dark fs-4 w-100 mt-2" :disabled="gettingProbes || savingProbe || deletingProbe || poweringProbe" @click="getProbes(); probes=[];">
                        <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': gettingProbes || savingProbe || deletingProbe || poweringProbe}"></i>
                    </button>
                    <button v-show="mode=='addition'" class="btn btn-synapse-dark text-white fs-4 w-100 mt-2" data-bs-toggle="modal" data-bs-target="#new-credential" @click="new_credential = cloneObject(dnew_credential)">
                        <i class="fa-solid fa-xl fa-key me-2 fs-3"></i>
                        <i class="fa-solid fa-xl fa-plus fs-3"></i>
                    </button>
                </div>
            </div>  
            <div class="col-md-1">
                <div class="">
                    <button v-show="mode=='default'" class="btn btn-synapse-dark fs-4 w-100 mt-2" :disabled="addingProbe" @click="setAddition();">
                        <i class="fa-solid fa-xl fa-plus"></i>
                    </button>
                    <button v-show="mode=='addition'" class="btn btn-danger text-white fs-4 w-100 mt-2" @click="closeAddition(); getProbes();">
                        <i class="fa-solid fa-xl fa-close"></i>
                    </button>
                </div>
            </div>
        </div>
        
        <!-- Probes Main View -->
        <div v-show="mode=='default'" class="row">
          <div class="col-md-12">
            <div class="rounded p-1" :class="{'disabled-div': gettingProbes || deletingProbe || poweringProbe}">
              <div class="tableFixHead mt-1" style="height: 570px;">
                  <table>
                      <thead>
                          <tr>
                              <th class="fw-light bg-black fs-5 rounded border-bottom-synapse border-top-synapse" style="color: rgb(52, 143, 186); width: 10px;" title="#">
                                  <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                              </th>
                              <th class="fw-light bg-black fs-5 border-bottom-synapse border-top-synapse" style="color: rgb(52, 143, 186); width: 120px;" title="Name/Alias">
                                    <select v-model="searchType_ind" class="btn btn-black fs-5" style="color: rgb(52, 143, 186);">
                                        <option value="name">Name</option>
                                        <option value="alias">Alias</option>
                                    </select>
                              </th>
                              <th class="fw-light bg-black fs-5 rounded border-bottom-synapse border-top-synapse" style="color: rgb(52, 143, 186); width: 30px;" title="Type">
                                  <i class="fa-solid fa-lg fa-cubes"></i>
                              </th>
                              <th class="fw-light bg-black fs-5 rounded border-bottom-synapse border-top-synapse" style="color: rgb(52, 143, 186); width: 50px;" title="Category">
                                  <i class="fa-solid fa-lg fa-cube"></i>
                              </th>
                              <th class="fw-light bg-black fs-5 rounded border-bottom-synapse border-top-synapse" style="color: rgb(52, 143, 186); width: 10px;" title="Edit probe.">
                                  <i class="fa-solid fa-lg fa-power-off"></i>
                              </th>
                              <th class="fw-light bg-black fs-5 rounded border-bottom-synapse border-top-synapse" style="color: rgb(52, 143, 186); width: 10px;" title="Edit probe.">
                                  <i class="fa-solid fa-lg fa-pen"></i>
                              </th>
                              <th class="fw-light bg-black fs-5 rounded border-bottom-synapse border-top-synapse" style="color: rgb(52, 143, 186); width: 10px;" title="Delete probe.">
                                  <i class="fa-solid fa-lg fa-trash"></i>
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(p, i) in filteredProbes" v-bind:key="i+1"> <!-- Content Row -->
                                <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                    <input type="text" class="btn bg-black text-white fw-light fs-5 text-center border-0 w-100" style="cursor: default;" :value="i+1" readonly>
                                </td>
                                <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                    <input type="text" class="btn bg-black text-white fw-light fs-5 text-center border-0 w-100" style="cursor: default;" :value="p[searchType_ind]" readonly>
                                </td>
                                <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                    <button class="btn btn-synapse-dark fw-light fs-6 w-100" :title="capitalize(p.type)">
                                        <i class="fa-solid fa-lg" :class="{'fa-globe': p.type =='url', 'fa-database': p.type =='databank', 'fa-rss': p.type=='ping', 'fa-road': p.type=='traceroute'}"></i>
                                    </button>
                                </td>
                                <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                    <button class="btn btn-synapse-dark fw-light fs-6 w-100">
                                        {{String(p.category).toUpperCase()}}
                                    </button>
                                </td>
                                <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                    <button class="btn fw-light fs-6 w-100" :class="{'btn-synapse-dark': p.active, 'bg-synapse-glass text-white': !p.active}" title="Power on/off probe." @click="powerProbe(p, i)">
                                        <i class="fa-solid fa-lg fa-power-off"></i>
                                    </button>
                                </td>
                                <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                    <button class="btn btn-synapse-dark fw-light fs-6 w-100" title="Edit probe." @click="setEdition(p)">
                                        <i class="fa-solid fa-lg fa-pen"></i>
                                    </button>
                                </td>
                                <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                    <button class="btn btn-synapse-dark fw-light fs-6 w-100" :title="'Delete ' + p[searchType]" @click="deleteProbe(p, i)">
                                        <i class="fa-solid fa-lg fa-trash"></i>
                                    </button>
                                </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Addition Section -->
        <div v-show="mode=='addition'" class="p-1" :class="{'disabled-div': blockProbe}">
            <!-- Name, Alias, Type, Category, Validate Button Section -->
            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="input-group flex-nowrap w-100">
                        <button class="btn rounded fs-3 me-1" title="URL" :class="{'bg-synapse-glass text-white': nprobe.type!='url', 'btn-synapse-dark': nprobe.type=='url'}" @click="nprobe.type = 'url'; nprobe.category = null; clearAddition('url');">
                            <i class="fa-solid fa-globe"></i>
                        </button>
                        <button v-if="false" class="btn rounded fs-3 me-1" title="Databank" :class="{'bg-synapse-glass text-white': nprobe.type!='databank', 'btn-synapse-dark': nprobe.type=='databank'}" @click="nprobe.type = 'databank'; nprobe.category = null; clearAddition('databank');">
                            <i class="fa-solid fa-database"></i>
                        </button>
                        <button class="btn rounded fs-3 me-1" title="Ping" :class="{'bg-synapse-glass text-white': nprobe.type!='ping', 'btn-synapse-dark': nprobe.type=='ping'}" @click="nprobe.type = 'ping'; nprobe.category = null; clearAddition('ping');">
                            <i class="fa-solid fa-rss"></i>
                        </button>
                        <button class="btn rounded fs-3 me-1" title="Traceroute" :class="{'bg-synapse-glass text-white': nprobe.type!='traceroute', 'btn-synapse-dark': nprobe.type=='traceroute'}" @click="nprobe.type = 'traceroute'; nprobe.category = null; clearAddition('traceroute');">
                            <i class="fa-solid fa-road"></i>
                        </button>
                        <select class="btn btn-synapse-dark rounded fs-4 me-2" style="width: 23%;" v-model="nprobe.category" :disabled="nprobe.type == null">
                            <option :value="null">Select a category...</option>"
                            <option v-for="(_category, catidx) in categories[nprobe.type]" v-bind:key="catidx+1" :value="_category.name">{{_category.alias}}</option>
                        </select>
                        <input type="text" class="btn bg-synapse-glass text-white fs-4 rounded me-2" style="width: 30%; cursor: text;" placeholder="Probe Name" v-model="nprobe.name" :disabled="nprobe.type == null">
                        <input type="text" class="btn bg-synapse-glass text-white fs-4 rounded me-2" style="width: 30%; cursor: text;" placeholder="Probe Alias" v-model="nprobe.alias" :disabled="nprobe.type == null">
                        <button class="btn btn-synapse-dark rounded fs-2" style="width: 15%;" title="Validate probe." @click="validateProbe" :disabled="nprobe.type == null">
                            <i class="fa-solid" :class="{'fa-refresh fa-spin': validatingProbe, 'fa-check': !validatingProbe}"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="p-1 rounded mt-3" style="height: 490px;">
                <!-- Selection -->
                <div  v-if="nprobe.type==null">
                    <div class="" style="height: 500px;">
                        <input class="btn bg-transparent fs-1 w-100" type="text" style="margin-top: 14%; letter-spacing: 8px;" value="Select a probe type." readonly>
                    </div>
                </div>
                <!-- URL -->
                <div v-if="nprobe.type=='url'">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="p-1 rounded">
                                <input type="text" class="fw-light btn bg-transparent text-white fs-3 w-100" value="URL Probe" readonly>
                            </div>
                        </div>
                        <!-- Endpoint, Timeout Section -->
                        <div class="col-md-9">
                            <div class="rounded">
                                <div class="input-group flex-nowrap">
                                    <button class="btn fs-3 rounded" style="width: 10%;" :class="{'btn-synapse-dark': nprobe.active, 'bg-synapse-glass text-white': !nprobe.active}" @click="nprobe.active = !nprobe.active">
                                        <i class="fa-solid fa-globe"></i>
                                    </button>
                                    <input type="text" v-model="nurl.endpoint" class="btn bg-synapse-glass text-white fs-5 rounded w-100 me-2" style="cursor: text;" placeholder="Endpoint (URL)">
                                    <button class="btn btn-synapse-dark fs-3 rounded">
                                        <i class="fa-solid fa-clock"></i>
                                    </button>
                                    <input type="number" v-model.number="nurl.timeout" class="btn bg-synapse-glass text-white fs-4" style="cursor: text; width:21%;" placeholder="Timeout">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Method, Credential, Certificate, Parameters Section -->
                        <div class="col-md-5">
                            <div class="rounded mt-1">
                                <div class="input-group flex-nowrap">
                                    <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" title="This is the HTTP method to use in the request: [ POST , GET ]" tabindex="-1">
                                        <i class="fa-solid fa-paper-plane"></i>
                                    </button>
                                    <select class="btn bg-synapse-glass text-white fs-5 w-100 text-start" v-model="nurl.method">
                                        <option :value="null">Select a method...</option>"
                                        <option value="get">GET</option>
                                        <option value="post">POST</option>
                                    </select>
                                </div>
                                <div class="mt-2" name="argroup">
                                    <div class="input-group flex-nowrap w-100">
                                        <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 22%;" tabindex="-1">
                                            <i class="fa-solid fa-paperclip"></i>
                                        </button>
                                        <input type="text" class="btn bg-synapse-glass text-white text-white fs-5 w-100" value="" placeholder="Parameter Name" v-model="argname">
                                        <input type="text" class="btn bg-synapse-glass text-white text-white fs-5 w-100" value="" placeholder="Parameter Value" v-model="argvalue">
                                        <button class="btn btn-synapse-dark fs-4 rounded" style="width: 12%;" tabindex="-1" @click="addArgument">
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                    </div>
                                    <div class="bg-synapse-glass p-1 rounded" style="height: 247px; overflow-y: auto;">
                                        <div class="input-group flex-nowrap mt-1" v-for="(_args, _argi) in narguments" v-bind:key="_argi">
                                            <button class="btn btn-synapse-dark bg-gradient rounded">
                                                {{_argi+1}}
                                            </button>
                                            <input type="text" class="btn btn-synapse-dark ms-1 bg-gradient rounded w-100" :value="_args[0]">
                                            <input type="text" class="btn btn-synapse-dark ms-1 me-1 bg-gradient rounded w-100" :value="_args[1]">
                                            <button class="btn btn-synapse-dark bg-gradient rounded" @click="removeArgument(_argi)">
                                                <i class="fa-solid fa-minus"></i>
                                            </button>
                                        </div>
                                        <p v-if="narguments.length == 0" class="fs-4" style="margin-top: 15%;">Current parameters.</p>
                                    </div>
                                </div>
                                <div class="input-group flex-nowrap mt-2">
                                    <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" title="This is the credentials (if neccesary) to use to authenticate the request." tabindex="-1" @click="getCredentials" :disabled="gettingCredentials">
                                        <i class="fa-solid" :class="{'fa-key': !gettingCredentials, 'fa-refresh fa-spin': gettingCredentials}"></i>
                                    </button>
                                    <select class="btn bg-synapse-glass text-white rounded fs-5 w-100 text-start" v-model="nurl.credentials" :disabled="credentials.length == 0 || gettingCredentials">
                                        <option :value="null">Select a credential...</option>"
                                        <option v-for="(_credential, _crdi) in credentials" :value="_credential.uid" v-bind:key="_crdi+1">{{`${_credential.alias} (${capitalize(_credential.type)})`}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <!-- Tolerance Section -->
                        <div class="col-md-7">
                            <div class="bg-synapse-glass rounded p-2 mt-1" style="height: 99%;">
                                <p class="fs-4 text-white fw-light">Tolerances</p>
                                <!-- Latency Tolerance Section -->
                                <div class="input-group flex-nowrap rounded" :class="{'bg-synapse-dark': nurl.exec_latency_tolerance}">
                                    <button class="btn fs-3" :class="{'btn-synapse-dark': nurl.exec_latency_tolerance, 'bg-black text-white': !nurl.exec_latency_tolerance }" title="Latency Tolerance" style="width: 13%;" @click="nurl.exec_latency_tolerance = !nurl.exec_latency_tolerance; nurl.latency_tolerance = null;">
                                        <i class="fa-solid fa-clock"></i>
                                    </button>
                                    <input type="text" class="btn bg-black text-white fs-4" style="width: 30%;" value="Latency" readonly :disabled="!nurl.exec_latency_tolerance">
                                    <div class="btn bg-black text-white p-2" style="width: 70%;" :class="{'disabled-div': !nurl.exec_latency_tolerance}">
                                        <input type="range" class="form-range mt-2" min="1" max="30000" v-model.number="nurl.latency_tolerance" :disabled="!nurl.exec_latency_tolerance">
                                    </div>
                                    <input type="number" v-model.number="nurl.latency_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!nurl.exec_latency_tolerance">
                                    <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': nurl.exec_latency_tolerance, 'bg-black text-white': !nurl.exec_latency_tolerance }" style="width: 15%;" value="ms" :disabled="!nurl.exec_latency_tolerance"  readonly>
                                </div>
                                <!-- Similarity Tolerance Section -->
                                <div class="input-group flex-nowrap mt-2">
                                    <button class="btn fs-3" :class="{'btn-synapse-dark': nurl.exec_similarity_tolerance, 'bg-black text-white': !nurl.exec_similarity_tolerance }" title="Similarity Tolerance" style="width: 13%;" @click="nurl.exec_similarity_tolerance = !nurl.exec_similarity_tolerance; nurl.similarity_tolerance = null;">
                                        <i class="fa-solid fa-percent"></i>
                                    </button>
                                    <input type="text" class="btn bg-black text-white fs-4" style="width: 30%;" value="Similarity" readonly :disabled="!nurl.exec_similarity_tolerance">
                                    <div class="btn bg-black text-white p-2"  style="width: 70%;" :class="{'disabled-div': !nurl.exec_similarity_tolerance}">
                                        <input type="range" class="form-range mt-2" min="1" max="100" v-model.number="nurl.similarity_tolerance" :disabled="!nurl.exec_similarity_tolerance">
                                    </div>
                                    <input type="number" v-model.number="nurl.similarity_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!nurl.exec_similarity_tolerance">
                                    <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': nurl.exec_similarity_tolerance, 'bg-black text-white': !nurl.exec_similarity_tolerance }" style="width: 15%;" value="%" :disabled="!nurl.exec_similarity_tolerance" readonly>
                                </div>
                                <!-- Status Code Tolerance Section -->
                                <div class="input-group flex-nowrap mt-2">
                                    <button class="btn fs-3" :class="{'btn-synapse-dark': nurl.exec_status_code_tolerance, 'bg-black text-white': !nurl.exec_status_code_tolerance }" title="Status Code Tolerance" style="width: 13%;" @click="nurl.exec_status_code_tolerance = !nurl.exec_status_code_tolerance; nurl.status_code_tolerance=[];">
                                        <i class="fa-solid fa-code"></i>
                                    </button>
                                    <input type="text" class="btn bg-black text-white fs-4"  style="width: 30%;" value="Codes" :disabled="!nurl.exec_status_code_tolerance" readonly>
                                    <input type="number" v-model.number="nstatuscode" class="btn bg-black text-white fs-4" style="cursor: text; width: 50%;" placeholder="Status Code" :disabled="!nurl.exec_status_code_tolerance">
                                    <button class="btn fs-3" :class="{'btn-synapse-dark': nurl.codes_whitelist, 'bg-black text-white': !nurl.codes_whitelist }" title="Set the list mode." style="width: 13%;" :disabled="!nurl.exec_status_code_tolerance"
                                        @click="nurl.codes_whitelist = !nurl.codes_whitelist">
                                            <i class="fa-solid fa-list-check"></i>
                                    </button>
                                    <button class="btn fs-3" :class="{'btn-synapse-dark': nurl.exec_status_code_tolerance, 'bg-black text-white': !nurl.exec_status_code_tolerance }" title="Status Code Tolerance" style="width: 13%;" :disabled="!nurl.exec_status_code_tolerance"
                                        @click="nurl.status_code_tolerance.push(nstatuscode); nstatuscode=null;">
                                            <i class="fa-solid fa-plus"></i>
                                    </button>
                                </div>
                                <div class="bg-glass-light rounded p-1 w-100" :class="{'bg-glass-light': !nurl.exec_status_code_tolerance , 'bg-synapse-glass': nurl.exec_status_code_tolerance}" name="scgroup">
                                    <div class="p-1 rounded" style="height: 150px; overflow-y: auto;">
                                        <div class="input-group flex-nowrap mt-1" v-for="(_scv, _sci) in nurl.status_code_tolerance" v-bind:key="_sci">
                                            <button class="btn btn-synapse-dark bg-gradient rounded">
                                                {{_sci+1}}
                                            </button>
                                            <input type="text" class="btn btn-synapse-dark ms-1 me-1 bg-gradient rounded w-100" :value="_scv">
                                            <button class="btn btn-synapse-dark bg-gradient rounded" @click="nurl.status_code_tolerance.splice(_sci, 1);">
                                                <i class="fa-solid fa-minus"></i>
                                            </button>
                                        </div>
                                        <p v-if="nurl.status_code_tolerance.length == 0 && nurl.exec_status_code_tolerance" class="fs-4" style="margin-top: 5%;">Current valid codes.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- Databank -->
                <div v-if="nprobe.type=='databank'"  class="">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="p-1 rounded">
                                <input type="text" class="fw-light btn bg-transparent text-white fs-3 w-100" value="Databank Probe" readonly>
                            </div>
                        </div>
                        <!-- Server, Timeout Section -->
                        <div class="col-md-8">
                            <div>
                                <div class="input-group flex-nowrap">
                                    <button class="btn fs-3 rounded" style="width: 10%;" :class="{'btn-synapse-dark': nprobe.active, 'bg-synapse-glass text-white': !nprobe.active}" @click="nprobe.active = !nprobe.active">
                                        <i class="fa-solid fa-database"></i>
                                    </button>
                                    <input type="text" v-model="ndb.server" class="btn bg-synapse-glass text-white fs-5 rounded w-100 me-2" style="cursor: text;" placeholder="Server">
                                    <button class="btn btn-synapse-dark fs-3 rounded">
                                        <i class="fa-solid fa-clock"></i>
                                    </button>
                                    <input type="number" v-model.number="ndb.timeout" class="btn bg-synapse-glass text-white fs-4" style="cursor: text; width:21%;" placeholder="Timeout">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Schema, Table, Args, Credentials Section -->
                        <div class="col-md-4">
                            <div class="input-group flex-nowrap">
                                <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" tabindex="-1">
                                    <i class="fa-solid fa-leaf"></i>
                                </button>
                                <input type="text" class="btn bg-synapse-glass text-white text-white fs-4 w-100" placeholder="Schema" v-model="ndb.schema">
                            </div>
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" tabindex="-1">
                                    <i class="fa-solid fa-table"></i>
                                </button>
                                <input type="text" class="btn bg-synapse-glass text-white text-white fs-4 w-100" placeholder="Table" v-model="ndb.table">
                            </div>
                            <div class="mt-2" name="argroup">
                                <div class="input-group flex-nowrap w-100">
                                    <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 13%;" tabindex="-1">
                                        <i class="fa-solid fa-paperclip"></i>
                                    </button>
                                    <input type="text" class="btn bg-synapse-glass text-white text-white fs-4 w-100" value="" placeholder="Parameter" v-model="argvalue">
                                    <button class="btn btn-synapse-dark fs-4 rounded" style="width: 12%;" tabindex="-1" @click="addArgument">
                                        <i class="fa-solid fa-plus"></i>
                                    </button>
                                </div>
                                <div class="bg-synapse-glass p-1 rounded" style="height: 190px; overflow-y: auto;">
                                    <div class="input-group flex-nowrap mt-1" v-for="(_argv, _argi) in narguments" v-bind:key="_argi">
                                        <button class="btn btn-synapse-dark bg-gradient rounded">
                                            {{_argi+1}}
                                        </button>
                                        <input type="text" class="btn btn-synapse-dark ms-1 me-1 bg-gradient rounded w-100" :value="_argv">
                                        <button class="btn btn-synapse-dark bg-gradient rounded" @click="removeArgument(_argi)">
                                            <i class="fa-solid fa-minus"></i>
                                        </button>
                                    </div>
                                    <p v-if="narguments.length == 0" class="fs-4" style="margin-top: 15%;">Current parameters.</p>
                                </div>
                            </div>
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" @click="getCredentials" title="This is the credentials (if neccesary) to use to authenticate the connection to the databank." tabindex="-1" :disabled="gettingCredentials">
                                    <i class="fa-solid" :class="{'fa-key': !gettingCredentials, 'fa-refresh fa-spin': gettingCredentials}"></i>
                                </button>
                                <select class="btn bg-synapse-glass text-white rounded fs-5 w-100 text-start" v-model="ndb.credentials" :disabled="credentials.length == 0 || gettingCredentials">
                                    <option :value="null">Select a credential...</option>"
                                    <option v-for="(_credential, _crdi) in credentials" :value="_credential.uid" v-bind:key="_crdi+1">{{`${_credential.alias} (${capitalize(_credential.type)})`}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="input-group flex-nowrap">
                                <button class="btn fs-3 rounded" style="width: 9%;" :class="{'btn-synapse-dark': ndb.exec_action, 'bg-synapse-glass text-white': !ndb.exec_action}" @click="ndb.exec_action = !ndb.exec_action; ndb.action=null; ndb.exec_action_latency_tolerance=false; ndb.action_latency_tolerance = null ">
                                    <i class="fa-solid fa-play"></i>
                                </button>
                                <input type="text" v-model="ndb.action" class="btn bg-synapse-glass text-white fs-5 rounded w-100" style="cursor: text;" placeholder="Action" :disabled="!ndb.exec_action">
                            </div>
                            <div class="bg-synapse-glass rounded p-2 mt-2" style="height: 85%;">
                                <p class="fs-4 text-white fw-light">Tolerances</p>
                                <!-- Latency Tolerance Section -->
                                <div class="input-group flex-nowrap rounded" :class="{'bg-synapse-dark': ndb.exec_latency_tolerance}">
                                    <button class="btn fs-3" :class="{'btn-synapse-dark': ndb.exec_latency_tolerance, 'bg-black text-white': !ndb.exec_latency_tolerance }" title="Latency Tolerance" style="width: 13%;" @click="ndb.exec_latency_tolerance = !ndb.exec_latency_tolerance; ndb.latency_tolerance = null;">
                                        <i class="fa-solid fa-clock"></i>
                                    </button>
                                    <input type="text" class="btn bg-black text-white fs-4" style="width: 50%;" value="Latency" readonly :disabled="!ndb.exec_latency_tolerance">
                                    <div class="btn bg-black text-white p-2" style="width: 70%;" :class="{'disabled-div': !ndb.exec_latency_tolerance}">
                                        <input type="range" class="form-range mt-2" min="1" max="30000" v-model.number="ndb.latency_tolerance" :disabled="!ndb.exec_latency_tolerance">
                                    </div>
                                    <input type="number" v-model.number="ndb.latency_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!ndb.exec_latency_tolerance">
                                    <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': ndb.exec_latency_tolerance, 'bg-black text-white': !ndb.exec_latency_tolerance }" style="width: 15%;" value="ms" :disabled="!ndb.exec_latency_tolerance" readonly>
                                </div>
                                <!-- Similarity Tolerance Section -->
                                <div class="input-group flex-nowrap mt-2">
                                    <button class="btn fs-3" :class="{'btn-synapse-dark': ndb.exec_similarity_tolerance, 'bg-black text-white': !ndb.exec_similarity_tolerance }" title="Similarity Tolerance" style="width: 13%;" @click="ndb.exec_similarity_tolerance = !ndb.exec_similarity_tolerance; ndb.similarity_tolerance = null;">
                                        <i class="fa-solid fa-percent"></i>
                                    </button>
                                    <input type="text" class="btn bg-black text-white fs-4" style="width: 50%;" value="Similarity" readonly :disabled="!ndb.exec_similarity_tolerance">
                                    <div class="btn bg-black text-white p-2" style="width: 70%;" :class="{'disabled-div': !ndb.exec_similarity_tolerance}">
                                        <input type="range" class="form-range mt-2" min="1" max="100" v-model.number="ndb.similarity_tolerance" :disabled="!ndb.exec_similarity_tolerance">
                                    </div>
                                    <input type="number" v-model.number="ndb.similarity_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!ndb.exec_similarity_tolerance">
                                    <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': ndb.exec_similarity_tolerance, 'bg-black text-white': !ndb.exec_similarity_tolerance }" style="width: 15%;" value="%" :disabled="!ndb.exec_similarity_tolerance" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Ping -->
                <div v-if="nprobe.type=='ping'"  class="">
                    <div class="row">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <div class="p-1 rounded">
                                <input type="text" class="fw-light btn bg-transparent text-white fs-2 w-100" value="Ping Probe" readonly>
                                <div class="input-group flex-nowrap">
                                    <button class="btn fs-3 rounded" style="width: 10%;" :class="{'btn-synapse-dark': nprobe.active, 'bg-synapse-glass text-white': !nprobe.active}" @click="nprobe.active = !nprobe.active">
                                        <i class="fa-solid fa-rss"></i>
                                    </button>
                                    <input type="text" v-model="nping.endpoint" class="btn bg-synapse-glass text-white fs-5 rounded w-100 me-2" style="cursor: text;" placeholder="Endpoint (IP or Domain)">
                                    <button class="btn btn-synapse-dark fs-3 rounded" title="Ping repeats." @click="nping.repeats = 10;">
                                        <i class="fa-solid fa-repeat"></i>
                                    </button>
                                    <input type="number" v-model.number="nping.repeats" min="1" class="btn bg-synapse-glass text-white fs-4" style="cursor: text; width:21%;" placeholder="Repeats">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2"></div>
                        <!-- Tolerance Section -->
                        <div class="col-md-8">
                            <div class="bg-synapse-glass rounded p-2 mt-2" style="height: 100%;">
                                <p class="fs-4 text-white fw-light">Tolerances</p>
                                <!-- Latency Tolerance Section -->
                                <div class="input-group flex-nowrap rounded" :class="{'bg-synapse-dark': nping.exec_latency_tolerance}">
                                    <button class="btn fs-3" :class="{'btn-synapse-dark': nping.exec_latency_tolerance, 'bg-black text-white': !nping.exec_latency_tolerance }" title="Latency Tolerance" style="width: 13%;" @click="nping.exec_latency_tolerance = !nping.exec_latency_tolerance; nping.latency_tolerance = null;">
                                        <i class="fa-solid fa-clock"></i>
                                    </button>
                                    <input type="text" class="btn bg-black text-white fs-4" style="width: 50%;" value="Latency" readonly :disabled="!nping.exec_latency_tolerance">
                                    <div class="btn bg-black text-white p-2" style="width: 70%;" :class="{'disabled-div': !nping.exec_latency_tolerance}">
                                        <input type="range" class="form-range mt-2" min="1" max="30000" v-model.number="nping.latency_tolerance" :disabled="!nping.exec_latency_tolerance">
                                    </div>
                                    <input type="number" v-model.number="nping.latency_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!nping.exec_latency_tolerance">
                                    <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': nping.exec_latency_tolerance, 'bg-black text-white': !nping.exec_latency_tolerance }" style="width: 15%;" value="ms" :disabled="!nping.exec_latency_tolerance" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Traceroute -->
                <div v-if="nprobe.type=='traceroute'"  class="">
                    <!-- Endpoint -->
                    <div class="row">
                        <div class="col-md-1"></div>
                        <div class="col-md-10">
                            <div class="p-1 rounded">
                                <input type="text" class="fw-light btn bg-transparent text-white fs-2 w-100" value="Traceroute Probe" readonly>
                                <div class="input-group flex-nowrap">
                                    <button class="btn fs-3 rounded" style="cursor: pointer;" :class="{'btn-synapse-dark': nprobe.active, 'bg-synapse-glass text-white': !nprobe.active}" @click="nprobe.active = !nprobe.active">
                                        <i class="fa-solid fa-road"></i>
                                    </button>
                                    <input type="text" v-model="ntrace.endpoint" class="btn bg-synapse-glass text-white fs-5 rounded w-100" style="cursor: text;" placeholder="Endpoint" @change="resolveEndpoint(ntrace.endpoint); ntrace.endpoint_ip=null;" :disabled="resolving">
                                    <select class="btn bg-synapse-glass text-white fs-5 rounded w-100" v-model="ntrace.endpoint_ip" :disabled="resolving">
                                        <option :value="null">Endpoint IP</option>
                                        <option :value="_ri" v-for="(_ri, _ridx) in resolvedIPS" v-bind:key="_ridx">{{_ri}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Hops & Timeout Section -->
                    <div class="row">
                        <div class="col-md-1"></div>
                        <div class="col-md-10">
                            <div class="p-1 rounded">
                                <div class="input-group flex-nowrap w-100">
                                    <button class="btn btn-synapse-dark fs-3 rounded w-25" title="Traceroute Max Hops." @click="ntrace.max_hops = 10;">
                                        <i class="fa-solid fa-frog"></i>
                                    </button>
                                    <input type="number" v-model.number="ntrace.max_hops" class="btn bg-synapse-glass text-white fs-4 w-75 me-2 rounded" style="cursor: text;" placeholder="Max Hops">
                                    <button class="btn btn-synapse-dark fs-3 rounded w-25" title="Traceroute timeout." @click="ntrace.timeout = 10;">
                                        <i class="fa-solid fa-clock"></i>
                                    </button>
                                    <input type="number" v-model.number="ntrace.timeout" class="btn bg-synapse-glass text-white fs-4 w-75" style="cursor: text;" placeholder="Traceroute timeout.">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1"></div>
                        <!-- Tolerance Section -->
                        <div class="col-md-10">
                            <div class="bg-synapse-glass rounded p-2 mt-2" style="height: 100%;">
                                <p class="fs-4 text-white fw-light">Tolerances</p>
                                <!-- Reached -->
                                <div class="input-group flex-nowrap mt-2">
                                    <button class="btn fs-5 w-50" :class="{'btn-synapse-dark': ntrace.exec_connectivity, 'bg-black text-white': !ntrace.exec_connectivity }" title="Reached destination: controls if an alarm is generated when the destination is unreachable." @click="ntrace.exec_connectivity = !ntrace.exec_connectivity;">
                                        <i class="fa-solid fa-road-circle-check me-3"></i>
                                        <span class="fw-light">Reached</span>
                                    </button>
                                    <button class="btn fs-5 w-50 ms-1 me-1" :class="{'btn-synapse-dark': ntrace.exec_trace_length, 'bg-black text-white': !ntrace.exec_trace_length }" title="Traceroute length: controls if an alarm is generated when the length of the traceroute change." @click="ntrace.exec_trace_length = !ntrace.exec_trace_length;">
                                        <i class="fa-solid fa-ruler me-3"></i>
                                        <span class="fw-light">Traceroute Length</span>
                                    </button>
                                    <button class="btn fs-5 w-50" :class="{'btn-synapse-dark': ntrace.exec_hops_change, 'bg-black text-white': !ntrace.exec_hops_change }" title="Hops change: controls if an alarm is generated when at least one hop is different." @click="ntrace.exec_hops_change = !ntrace.exec_hops_change;">
                                        <i class="fa-solid fa-bezier-curve me-3"></i>
                                        <span class="fw-light">Hops Change</span>
                                    </button>
                                    <input type="number" class="btn fs-5" style="width: 13%;" :class="{'btn-synapse-dark': ntrace.exec_hops_change, 'bg-black text-white': !ntrace.exec_hops_change }" placeholder="HCT" title="Hops Change Tolerance" v-model.number="ntrace.hops_change_tolerance" :disabled="!ntrace.exec_hops_change">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edition Section -->
        <div v-show="mode=='edition' && eprobe.type != null" :class="{'disabled-div': savingProbe}" class="p-1">
            <!-- Header -->
            <div class="row">
                <div class="col-md-3">
                    <p class="fs-2 fw-light text-white text-center text-start mt-2 ms-2" style="letter-spacing: 10px;">Edit Probe</p>
                </div>
                <div class="col-md-7"></div>
                <div class="col-md-1">
                    <button class="btn btn-synapse-dark fs-3 w-100" data-bs-toggle="modal" data-bs-target="#manage-notificators" :disabled="gettingNotificators">
                        <i class="fa-solid fa-lg fa-bell" :class="{'fa-shake': gettingNotificators}"></i>
                    </button>
                </div>
                <div class="col-md-1">
                    <button class="btn btn-synapse-dark fs-3 w-100" @click="closeAddition">
                        <i class="fa-solid fa-lg fa-pen fa-beat"></i>
                    </button>
                </div>
            </div>
            <!-- Name, Alias, Type, Category Section -->
            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="input-group flex-nowrap w-100">
                        <input type="text" class="btn btn-synapse-dark text-white fs-4 rounded me-2" style="width: 35%; cursor: text;" placeholder="Probe Name" v-model="eprobe.name" readonly>
                        <input type="text" class="btn btn-synapse-dark text-white fs-4 rounded me-2" style="width: 35%; cursor: text;" placeholder="Probe Alias" v-model="eprobe.alias" readonly>
                        <button class="btn btn-synapse-dark rounded fs-4 me-2" style="width: 30%;">
                            <i class="fa-solid" :class="{'fa-globe': eprobe.type=='url', 
                                                         'fa-database': eprobe.type=='databank',
                                                         'fa-rss': eprobe.type=='ping',
                                                         'fa-road': eprobe.type=='traceroute'}"></i>
                            {{capitalize(eprobe.type)}}
                        </button>
                        <input type="text" class="btn btn-synapse-dark text-white fs-4 rounded" style="width: 30%; cursor: text;" placeholder="Probe Category" v-model="eprobe.category" readonly>
                    </div>
                </div>
            </div>
            <!-- URL -->
            <div v-if="eprobe.type == 'url'">
                <!-- URL -->
                <div class="row mt-2">
                    <!-- Endpoint, Timeout Section -->
                    <div class="col-md-12">
                        <div class="rounded">
                            <div class="input-group flex-nowrap">
                                <button class="btn fs-3 rounded" style="width: 10%;" :class="{'btn-synapse-dark': eprobe.active, 'bg-synapse-glass text-white': !eprobe.active}" @click="eprobe.active = !eprobe.active;">
                                    <i class="fa-solid fa-power-off"></i>
                                </button>
                                <input type="text" v-model="eprobe.endpoint" class="btn bg-synapse-glass text-white fs-5 rounded w-100 me-2" style="cursor: text;" placeholder="Endpoint (URL)">
                                <button class="btn btn-synapse-dark fs-3 rounded">
                                    <i class="fa-solid fa-clock"></i>
                                </button>
                                <input type="number" v-model.number="eprobe.timeout" class="btn bg-synapse-glass text-white fs-4" style="cursor: text; width:21%;" placeholder="Timeout">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <!-- Method, Credential, Cetificate, Parameters Section -->
                    <div class="col-md-5">
                        <div class="rounded">
                            <div class="input-group flex-nowrap">
                                <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" title="This is the HTTP method to use in the request: [ POST , GET ]" tabindex="-1">
                                    <i class="fa-solid fa-paper-plane"></i>
                                </button>
                                <select class="btn bg-synapse-glass text-white fs-5 w-100 text-start" v-model="eprobe.method">
                                    <option :value="null">Select a method...</option>"
                                    <option value="get">GET</option>
                                    <option value="post">POST</option>
                                </select>
                            </div>
                            <div class="mt-2" name="argroup">
                                <div class="input-group flex-nowrap w-100">
                                    <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 22%;" tabindex="-1">
                                        <i class="fa-solid fa-paperclip"></i>
                                    </button>
                                    <input type="text" class="btn bg-synapse-glass text-white text-white fs-5 w-100" value="" placeholder="Parameter Name" v-model="argname">
                                    <input type="text" class="btn bg-synapse-glass text-white text-white fs-5 w-100" value="" placeholder="Parameter Value" v-model="argvalue">
                                    <button class="btn btn-synapse-dark fs-4 rounded" style="width: 12%;" tabindex="-1" @click="addArgument">
                                        <i class="fa-solid fa-plus"></i>
                                    </button>
                                </div>
                                <div class="bg-synapse-glass p-1 rounded" style="height: 281px; overflow-y: auto;">
                                    <div class="input-group flex-nowrap mt-1" v-for="(_args, _argi) in narguments" v-bind:key="_argi">
                                        <button class="btn btn-synapse-dark bg-gradient rounded">
                                            {{_argi+1}}
                                        </button>
                                        <input type="text" class="btn btn-synapse-dark ms-1 bg-gradient rounded w-100" :value="_args[0]">
                                        <input type="text" class="btn btn-synapse-dark ms-1 me-1 bg-gradient rounded w-100" :value="_args[1]">
                                        <button class="btn btn-synapse-dark bg-gradient rounded" @click="removeArgument(_argi)">
                                            <i class="fa-solid fa-minus"></i>
                                        </button>
                                    </div>
                                    <p v-if="narguments.length == 0" class="fs-4" style="margin-top: 15%;">Current parameters.</p>
                                </div>
                            </div>
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" title="This is the credentials (if neccesary) to use to authenticate the request." tabindex="-1" @click="getCredentials" :disabled="gettingCredentials">
                                    <i class="fa-solid" :class="{'fa-key': !gettingCredentials, 'fa-refresh fa-spin': gettingCredentials}"></i>
                                </button>
                                <select class="btn bg-synapse-glass text-white rounded fs-5 w-100 text-start" v-model="eprobe.credentials" :disabled="credentials.length == 0 || gettingCredentials">
                                    <option :value="null">Select a credential...</option>"
                                    <option v-for="(_credential, _crdi) in credentials" :value="_credential.uid" v-bind:key="_crdi+1">{{`${_credential.alias} (${capitalize(_credential.type)})`}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- Tolerance Section -->
                    <div class="col-md-7">
                        <div class="bg-synapse-glass rounded p-2 mt-1" style="height: 86%;">
                            <p class="fs-4 text-white fw-light">Tolerances</p>
                            <!-- Latency Tolerance Section -->
                            <div class="input-group flex-nowrap rounded" :class="{'bg-synapse-dark': eprobe.exec_latency_tolerance}">
                                <button class="btn fs-3" :class="{'btn-synapse-dark': eprobe.exec_latency_tolerance, 'bg-black text-white': !eprobe.exec_latency_tolerance }" title="Latency Tolerance" style="width: 13%;" @click="eprobe.exec_latency_tolerance = !eprobe.exec_latency_tolerance; eprobe.latency_tolerance = null;">
                                    <i class="fa-solid fa-clock"></i>
                                </button>
                                <input type="text" class="btn bg-black text-white fs-4" style="width: 30%;" value="Latency" readonly :disabled="!eprobe.exec_latency_tolerance">
                                <div class="btn bg-black text-white p-2" style="width: 70%;" :class="{'disabled-div': !eprobe.exec_latency_tolerance}">
                                    <input type="range" class="form-range mt-2" min="1" max="30000" v-model.number="eprobe.latency_tolerance" :disabled="!eprobe.exec_latency_tolerance">
                                </div>
                                <input type="number" v-model.number="eprobe.latency_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!eprobe.exec_latency_tolerance">
                                <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': eprobe.exec_latency_tolerance, 'bg-black text-white': !eprobe.exec_latency_tolerance }" style="width: 15%;" value="ms" :disabled="!eprobe.exec_latency_tolerance"  readonly>
                            </div>
                            <!-- Similarity Tolerance Section -->
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn fs-3" :class="{'btn-synapse-dark': eprobe.exec_similarity_tolerance, 'bg-black text-white': !eprobe.exec_similarity_tolerance }" title="Similarity Tolerance" style="width: 13%;" @click="eprobe.exec_similarity_tolerance = !eprobe.exec_similarity_tolerance; eprobe.similarity_tolerance = null;">
                                    <i class="fa-solid fa-percent"></i>
                                </button>
                                <input type="text" class="btn bg-black text-white fs-4" style="width: 30%;" value="Similarity" readonly :disabled="!eprobe.exec_similarity_tolerance">
                                <div class="btn bg-black text-white p-2"  style="width: 70%;" :class="{'disabled-div': !eprobe.exec_similarity_tolerance}">
                                    <input type="range" class="form-range mt-2" min="1" max="100" v-model.number="eprobe.similarity_tolerance" :disabled="!eprobe.exec_similarity_tolerance">
                                </div>
                                <input type="number" v-model.number="eprobe.similarity_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!eprobe.exec_similarity_tolerance">
                                <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': eprobe.exec_similarity_tolerance, 'bg-black text-white': !eprobe.exec_similarity_tolerance }" style="width: 15%;" value="%" :disabled="!eprobe.exec_similarity_tolerance" readonly>
                            </div>
                            <!-- Status Code Tolerance Section -->
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn fs-3" :class="{'btn-synapse-dark': eprobe.exec_status_code_tolerance, 'bg-black text-white': !eprobe.exec_status_code_tolerance }" title="Status Code Tolerance" style="width: 13%;" @click="eprobe.exec_status_code_tolerance = !eprobe.exec_status_code_tolerance; eprobe.status_code_tolerance=[];">
                                    <i class="fa-solid fa-code"></i>
                                </button>
                                <input type="text" class="btn bg-black text-white fs-4"  style="width: 30%;" value="Codes" :disabled="!eprobe.exec_status_code_tolerance" readonly>
                                <input type="number" v-model.number="nstatuscode" class="btn bg-black text-white fs-4" style="cursor: text; width: 50%;" placeholder="Status Code" :disabled="!eprobe.exec_status_code_tolerance">
                                <button class="btn fs-3" :class="{'btn-synapse-dark': eprobe.codes_whitelist, 'bg-black text-white': !eprobe.codes_whitelist }" title="Set the list mode." style="width: 13%;" :disabled="!eprobe.exec_status_code_tolerance"
                                        @click="eprobe.codes_whitelist = !eprobe.codes_whitelist">
                                            <i class="fa-solid fa-list-check"></i>
                                    </button>
                                <button class="btn fs-3" :class="{'btn-synapse-dark': eprobe.exec_status_code_tolerance, 'bg-black text-white': !eprobe.exec_status_code_tolerance }" title="Status Code Tolerance" style="width: 13%;" :disabled="!eprobe.exec_status_code_tolerance"
                                @click="eprobe.status_code_tolerance.push(nstatuscode); nstatuscode=null;">
                                    <i class="fa-solid fa-plus"></i>
                                </button>
                            </div>
                            <div class="bg-glass-light rounded p-1 w-100" :class="{'bg-glass-light': !eprobe.exec_status_code_tolerance , 'bg-synapse-glass': eprobe.exec_status_code_tolerance}" name="scgroup">
                                <div class="p-1 rounded" style="height: 123px; overflow-y: auto;">
                                    <div class="input-group flex-nowrap mt-1" v-for="(_scv, _sci) in eprobe.status_code_tolerance" v-bind:key="_sci">
                                        <button class="btn btn-synapse-dark bg-gradient rounded">
                                            {{_sci+1}}
                                        </button>
                                        <input type="text" class="btn btn-synapse-dark ms-1 me-1 bg-gradient rounded w-100" :value="_scv">
                                        <button class="btn btn-synapse-dark bg-gradient rounded" @click="eprobe.status_code_tolerance.splice(_sci, 1);">
                                            <i class="fa-solid fa-minus"></i>
                                        </button>
                                    </div>
                                    <p v-if="eprobe.status_code_tolerance.length == 0 && eprobe.exec_status_code_tolerance" class="fs-4" style="margin-top: 5%;">Current valid codes.</p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <button class="btn btn-synapse-dark bg-gradient w-100 fs-4" @click="saveProbe">
                                <i class="fa-solid fa-lg" :class="{'fa-check': !savingProbe, 'fa-refresh fa-spin': savingProbe}"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Databank -->
            <div v-if="eprobe.type == 'databank'">
                <div class="row mt-2">
                    <!-- Server, Timeout Section -->
                    <div class="col-md-12">
                        <div class="rounded">
                            <div class="input-group flex-nowrap">
                                <button class="btn fs-3 rounded" style="width: 10%;" :class="{'btn-synapse-dark': eprobe.active, 'bg-synapse-glass text-white': !eprobe.active}" @click="eprobe.active = !eprobe.active;">
                                    <i class="fa-solid fa-power-off"></i>
                                </button>
                                <input type="text" v-model="eprobe.server" class="btn bg-synapse-glass text-white fs-5 rounded w-100 me-2" style="cursor: text;" placeholder="Server">
                                <button class="btn btn-synapse-dark fs-3 rounded">
                                    <i class="fa-solid fa-clock"></i>
                                </button>
                                <input type="number" v-model.number="eprobe.timeout" class="btn bg-synapse-glass text-white fs-4" style="cursor: text; width:21%;" placeholder="Timeout">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <!-- Schema, Table, Args, Credentials Section -->
                    <div class="col-md-4">
                        <div class="input-group flex-nowrap">
                            <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" tabindex="-1">
                                <i class="fa-solid fa-leaf"></i>
                            </button>
                            <input type="text" class="btn bg-synapse-glass text-white text-white fs-4 w-100" placeholder="Schema" v-model="eprobe.schema">
                        </div>
                        <div class="input-group flex-nowrap mt-2">
                            <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" tabindex="-1">
                                <i class="fa-solid fa-table"></i>
                            </button>
                            <input type="text" class="btn bg-synapse-glass text-white text-white fs-4 w-100" placeholder="Table" v-model="eprobe.table">
                        </div>
                        <div class="mt-2" name="argroup">
                            <div class="input-group flex-nowrap w-100">
                                <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 13%;" tabindex="-1">
                                    <i class="fa-solid fa-paperclip"></i>
                                </button>
                                <input type="text" class="btn bg-synapse-glass text-white text-white fs-4 w-100" value="" placeholder="Parameter" v-model="argvalue">
                                <button class="btn btn-synapse-dark fs-4 rounded" style="width: 12%;" tabindex="-1" @click="addArgument">
                                    <i class="fa-solid fa-plus"></i>
                                </button>
                            </div>
                            <div class="bg-synapse-glass p-1 rounded" style="height: 230px; overflow-y: auto;">
                                <div class="input-group flex-nowrap mt-1" v-for="(_argv, _argi) in narguments" v-bind:key="_argi">
                                    <button class="btn btn-synapse-dark bg-gradient rounded">
                                        {{_argi+1}}
                                    </button>
                                    <input type="text" class="btn btn-synapse-dark ms-1 me-1 bg-gradient rounded w-100" :value="_argv">
                                    <button class="btn btn-synapse-dark bg-gradient rounded" @click="removeArgument(_argi)">
                                        <i class="fa-solid fa-minus"></i>
                                    </button>
                                </div>
                                <p v-if="narguments.length == 0" class="fs-4" style="margin-top: 15%;">Current parameters.</p>
                            </div>
                        </div>
                        <div class="input-group flex-nowrap mt-2">
                            <button class="btn btn-synapse-dark fs-4 me-1 rounded" style="width: 12%;" @click="getCredentials" title="This is the credentials (if neccesary) to use to authenticate the connection to the databank." tabindex="-1" :disabled="gettingCredentials">
                                <i class="fa-solid" :class="{'fa-key': !gettingCredentials, 'fa-refresh fa-spin': gettingCredentials}"></i>
                            </button>
                            <select class="btn bg-synapse-glass text-white rounded fs-5 w-100 text-start" v-model="eprobe.credentials" :disabled="credentials.length == 0 || gettingCredentials">
                                <option :value="null">Select a credential...</option>"
                                <option v-for="(_credential, _crdi) in credentials" :value="_credential.uid" v-bind:key="_crdi+1">{{`${_credential.alias} (${capitalize(_credential.type)})`}}</option>
                            </select>
                        </div>
                    </div>
                    <!-- Action, Tolerances Section -->
                    <div class="col-md-8">
                        <div class="input-group flex-nowrap">
                            <button class="btn fs-3 rounded" style="width: 9%;" :class="{'btn-synapse-dark': eprobe.exec_action, 'bg-synapse-glass text-white': !eprobe.exec_action}" @click="eprobe.exec_action = !eprobe.exec_action; eprobe.action=null; eprobe.exec_action_latency_tolerance=false; eprobe.action_latency_tolerance = null ">
                                <i class="fa-solid fa-play"></i>
                            </button>
                            <input type="text" v-model="eprobe.action" class="btn bg-synapse-glass text-white fs-5 rounded w-100" style="cursor: text;" placeholder="Action" :disabled="!eprobe.exec_action">
                        </div>
                        <div class="bg-synapse-glass rounded p-2 mt-2" style="height: 73%;">
                            <p class="fs-4 text-white fw-light">Tolerances</p>
                            <!-- Latency Tolerance Section -->
                            <div class="input-group flex-nowrap rounded" :class="{'bg-synapse-dark': eprobe.exec_latency_tolerance}">
                                <button class="btn fs-3" :class="{'btn-synapse-dark': eprobe.exec_latency_tolerance, 'bg-black text-white': !eprobe.exec_latency_tolerance }" title="Latency Tolerance" style="width: 13%;" @click="eprobe.exec_latency_tolerance = !eprobe.exec_latency_tolerance; eprobe.latency_tolerance = null;">
                                    <i class="fa-solid fa-clock"></i>
                                </button>
                                <input type="text" class="btn bg-black text-white fs-4" style="width: 50%;" value="Latency" readonly :disabled="!eprobe.exec_latency_tolerance">
                                <div class="btn bg-black text-white p-2" style="width: 70%;" :class="{'disabled-div': !eprobe.exec_latency_tolerance}">
                                    <input type="range" class="form-range mt-2" min="1" max="30000" v-model.number="eprobe.latency_tolerance" :disabled="!eprobe.exec_latency_tolerance">
                                </div>
                                <input type="number" v-model.number="eprobe.latency_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!eprobe.exec_latency_tolerance">
                                <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': eprobe.exec_latency_tolerance, 'bg-black text-white': !eprobe.exec_latency_tolerance }" style="width: 15%;" value="ms" :disabled="!eprobe.exec_latency_tolerance" readonly>
                            </div>
                            <!-- Similarity Tolerance Section -->
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn fs-3" :class="{'btn-synapse-dark': eprobe.exec_similarity_tolerance, 'bg-black text-white': !eprobe.exec_similarity_tolerance }" title="Similarity Tolerance" style="width: 13%;" @click="eprobe.exec_similarity_tolerance = !eprobe.exec_similarity_tolerance; eprobe.similarity_tolerance = null;">
                                    <i class="fa-solid fa-percent"></i>
                                </button>
                                <input type="text" class="btn bg-black text-white fs-4" style="width: 50%;" value="Similarity" readonly :disabled="!eprobe.exec_similarity_tolerance">
                                <div class="btn bg-black text-white p-2" style="width: 70%;" :class="{'disabled-div': !eprobe.exec_similarity_tolerance}">
                                    <input type="range" class="form-range mt-2" min="1" max="100" v-model.number="eprobe.similarity_tolerance" :disabled="!eprobe.exec_similarity_tolerance">
                                </div>
                                <input type="number" v-model.number="eprobe.similarity_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!eprobe.exec_similarity_tolerance">
                                <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': eprobe.exec_similarity_tolerance, 'bg-black text-white': !eprobe.exec_similarity_tolerance }" style="width: 15%;" value="%" :disabled="!eprobe.exec_similarity_tolerance" readonly>
                            </div>
                        </div>
                        <div class="mt-2">
                            <button class="btn btn-synapse-dark fs-4 w-100" @click="saveProbe">
                                 <i class="fa-solid" :class="{'fa-check': !savingProbe, 'fa-refresh fa-spin': savingProbe}"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Ping -->
            <div v-if="eprobe.type == 'ping'">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <div class="p-1 rounded">
                            <input type="text" class="fw-light btn bg-transparent text-white fs-2 w-100" value="Ping Probe" readonly>
                            <div class="input-group flex-nowrap">
                                <button class="btn fs-3 rounded" style="width: 10%;" :class="{'btn-synapse-dark': eprobe.active, 'bg-synapse-glass text-white': !eprobe.active}" @click="eprobe.active = !eprobe.active">
                                    <i class="fa-solid fa-power-off"></i>
                                </button>
                                <input type="text" v-model="eprobe.endpoint" class="btn bg-synapse-glass text-white fs-5 rounded w-100 me-2" style="cursor: text;" placeholder="Endpoint (IP or Domain)">
                                <button class="btn btn-synapse-dark fs-3 rounded" title="Ping repeats." @click="eprobe.repeats = 10;">
                                    <i class="fa-solid fa-repeat"></i>
                                </button>
                                <input type="number" v-model.number="eprobe.repeats" class="btn bg-synapse-glass text-white fs-4" style="cursor: text; width:21%;" placeholder="Repeats">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2"></div>
                    <!-- Tolerance Section -->
                    <div class="col-md-8">
                        <div class="bg-synapse-glass rounded p-2 mt-2" style="height: 70%;">
                            <p class="fs-4 text-white fw-light">Tolerances</p>
                            <!-- Latency Tolerance Section -->
                            <div class="input-group flex-nowrap rounded" :class="{'bg-synapse-dark': eprobe.exec_latency_tolerance}">
                                <button class="btn fs-3" :class="{'btn-synapse-dark': eprobe.exec_latency_tolerance, 'bg-black text-white': !eprobe.exec_latency_tolerance }" title="Latency Tolerance" style="width: 13%;" @click="eprobe.exec_latency_tolerance = !eprobe.exec_latency_tolerance; eprobe.latency_tolerance = null;">
                                    <i class="fa-solid fa-clock"></i>
                                </button>
                                <input type="text" class="btn bg-black text-white fs-4" style="width: 50%;" value="Latency" readonly :disabled="!eprobe.exec_latency_tolerance">
                                <div class="btn bg-black text-white p-2" style="width: 70%;" :class="{'disabled-div': !eprobe.exec_latency_tolerance}">
                                    <input type="range" class="form-range mt-2" min="1" max="30000" v-model.number="eprobe.latency_tolerance" :disabled="!eprobe.exec_latency_tolerance">
                                </div>
                                <input type="number" v-model.number="eprobe.latency_tolerance" class="btn bg-black text-white fs-4" style="cursor: text;" placeholder="Tolerance" :disabled="!eprobe.exec_latency_tolerance">
                                <input type="text" class="btn fs-4 rounded" :class="{'btn-synapse-dark': eprobe.exec_latency_tolerance, 'bg-black text-white': !eprobe.exec_latency_tolerance }" style="width: 15%;" value="ms" :disabled="!eprobe.exec_latency_tolerance" readonly>
                            </div>
                        </div>
                        <div class="mt-3">
                            <button class="btn btn-synapse-dark fs-3 w-100" @click="saveProbe">
                                <i class="fa-solid" :class="{'fa-check': !savingProbe, 'fa-refresh fa-spin': savingProbe}"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Traceroute -->
            <div v-if="eprobe.type == 'traceroute'">
                <!-- Endpoint Section -->
                <div class="row">
                        <div class="col-md-1"></div>
                        <div class="col-md-10">
                            <div class="p-1 rounded">
                                <input type="text" class="fw-light btn bg-transparent text-white fs-2 w-100" value="Traceroute Probe" readonly>
                                <div class="input-group flex-nowrap">
                                    <button class="btn fs-3 rounded" style="cursor: pointer;" :class="{'btn-synapse-dark': eprobe.active, 'bg-synapse-glass text-white': !eprobe.active}" @click="eprobe.active = !eprobe.active">
                                        <i class="fa-solid fa-road"></i>
                                    </button>
                                    <input type="text" v-model="eprobe.endpoint" class="btn bg-synapse-glass text-white fs-5 rounded w-100" style="cursor: text;" placeholder="Endpoint">
                                    <input type="text" v-model="eprobe.endpoint_ip" class="btn bg-synapse-glass text-white fs-5 rounded w-100" style="cursor: text;" placeholder="Endpoint IP">
                                </div>
                            </div>
                        </div>
                </div>
                <!-- Hops & Timeout Section -->
                <div class="row">
                    <div class="col-md-1"></div>
                    <div class="col-md-10">
                        <div class="p-1 rounded">
                            <div class="input-group flex-nowrap w-100">
                                <button class="btn btn-synapse-dark fs-3 rounded w-25" title="Traceroute Max Hops." @click="eprobe.max_hops = 10;">
                                    <i class="fa-solid fa-frog"></i>
                                </button>
                                <input type="number" v-model.number="eprobe.max_hops" class="btn bg-synapse-glass text-white fs-4 w-75 me-2 rounded" style="cursor: text;" placeholder="Max Hops">
                                <button class="btn btn-synapse-dark fs-3 rounded w-25" title="Traceroute timeout." @click="eprobe.timeout = 20;">
                                    <i class="fa-solid fa-clock"></i>
                                </button>
                                <input type="number" v-model.number="eprobe.timeout" class="btn bg-synapse-glass text-white fs-4 w-75" style="cursor: text;" placeholder="Traceroute timeout.">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Tolerances Section -->
                <div class="row">
                    <div class="col-md-1"></div>
                    <!-- Tolerance Section -->
                    <div class="col-md-10">
                        <div class="bg-synapse-glass rounded p-2 mt-2" style="height: 70%;">
                            <p class="fs-4 text-white fw-light">Tolerances</p>
                            <!-- Reached -->
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn fs-5 w-50" :class="{'btn-synapse-dark': eprobe.exec_connectivity, 'bg-black text-white': !eprobe.exec_connectivity }" title="Reached destination: controls if an alarm is generated when the destination is unreachable." @click="eprobe.exec_connectivity = !eprobe.exec_connectivity;">
                                    <i class="fa-solid fa-road-circle-check me-3"></i>
                                    <span class="fw-light">Reached</span>
                                </button>
                                <button class="btn fs-5 w-50 ms-1 me-1" :class="{'btn-synapse-dark': eprobe.exec_trace_length, 'bg-black text-white': !eprobe.exec_trace_length }" title="Traceroute length: controls if an alarm is generated when the length of the traceroute change." @click="eprobe.exec_trace_length = !eprobe.exec_trace_length;">
                                    <i class="fa-solid fa-ruler me-3"></i>
                                    <span class="fw-light">Traceroute Length</span>
                                </button>
                                <button class="btn fs-5 w-50" :class="{'btn-synapse-dark': eprobe.exec_hops_change, 'bg-black text-white': !eprobe.exec_hops_change }" title="Hops change: controls if an alarm is generated when the destination is unreachable." @click="eprobe.exec_hops_change = !eprobe.exec_hops_change;">
                                    <i class="fa-solid fa-bezier-curve me-3"></i>
                                    <span class="fw-light">Hops Change</span>
                                </button>
                                <input type="number" class="btn fs-5" style="width: 13%;" :class="{'btn-synapse-dark': eprobe.exec_hops_change, 'bg-black text-white': !eprobe.exec_hops_change }" placeholder="HCT" title="Hops Change Tolerance" v-model.number="eprobe.hops_change_tolerance" :disabled="!eprobe.exec_hops_change">
                            </div>
                        </div>
                        <!-- Save Button Section -->
                        <div class="mt-3">
                            <button class="btn btn-synapse-dark fs-3 w-100" @click="saveProbe">
                                <i class="fa-solid" :class="{'fa-check': !savingProbe, 'fa-refresh fa-spin': savingProbe}"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tester Section -->
        <button id="trbutton"  style="display: none;" data-bs-toggle="modal" data-bs-target="#tester_results">Open Results</button>
        <div class="modal fade" id="tester_results" tabindex="-1">
            <div class="modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content bg-black">
                    <!-- Header -->
                    <div class="modal-header border-bottom border-info">
                        <div class="input-group flex-nowrap w-100">
                            <button class="btn bg-black text-white text-start fs-2" style="width: 90%; letter-spacing: 4px; cursor: default;">Validation results</button>
                            <button class="btn btn-danger rounded" title="Close probe results." data-bs-dismiss="modal" style="width: 10%;">
                                <i class="fa-solid fa-2xl fa-close"></i>
                            </button>
                        </div>
                    </div>
                    <!-- Body -->
                    <div class="modal-body bg-black">
                        <div v-if="test_results!=null">
                            <div class="input-group flex-nowrap">
                                <button class="btn btn-synapse-dark fs-2" style="width: 13%;">
                                    <i class="fa-solid fa-id-badge"></i>
                                </button>
                                <div class="input-group flex-nowrap">
                                    <input class="btn btn-synapse-dark fs-3 w-100 fw-light" style="letter-spacing: 4px;" type="text" :value="test_results.alias" readonly>
                                </div>
                            </div>
                            <div class="input-group flex-nowrap mt-2">
                                <button class="btn fs-2" :class="{'btn-synapse-dark': test_results.message.toLowerCase().includes('completed'), 'btn-danger': !test_results.message.toLowerCase().includes('completed')}" style="width: 13%;">
                                    <i class="fa-solid fa-message"></i>
                                </button>
                                <div class="input-group flex-nowrap">
                                    <input class="btn fs-3 w-100 fw-light" :class="{'btn-synapse-dark': test_results.message.toLowerCase().includes('completed'), 'btn-danger': !test_results.message.toLowerCase().includes('completed')}" style="letter-spacing: 2px;" type="text" :value="test_results.message" readonly>
                                </div>
                            </div>
                            <div class="input-group flex-nowrap mt-2 rounded">
                                <button class="btn fs-2 w-25 rounded me-1" :class="{'btn-synapse-dark': test_results.connectivity,
                                                                    'btn-danger': !test_results.connectivity}"  :title="`Connectivity: ${test_results.connectivity}`">
                                    <i class="fa-solid" :class="{'fa-link': test_results.connectivity,
                                                                'fa-link-slash': !test_results.connectivity}" ></i>

                                </button>
                                <button class="btn btn-synapse-dark fw-light fs-2 w-25 ms-1 rounded">
                                    <i class="fa-solid fa-clock me-3 mt-2"></i>
                                </button>
                                <input v-if="test_results.latency != null" class="btn btn-synapse-dark fw-light fs-2 w-75 rounded" type="text" :value="test_results.latency + ' ms'" readonly>
                                <input v-if="test_results.latency == null" class="btn btn-synapse-dark fw-light fs-2 w-75 rounded" type="text" value="Latency not retrieved." readonly>
                                <button v-if="test_results.type == 'traceroute' && test_results.hops != null" class="btn fw-light fs-2 w-25 rounded ms-2" :class="{'btn-synapse-dark': !viewHops, 'btn-synapse': viewHops}"
                                @click="viewHops = !viewHops" title="Click to view hops details.">
                                    <i class="fa-solid fa-frog me-2"></i>
                                    <span class="fw-light">{{test_results.hops.length}}</span>
                                </button>
                            </div>
                            <div v-if="probe.exec_latency_tolerance">
                                <div class="input-group flex-nowrap mt-2" v-if="test_results.latency > probe.latency_tolerance" >
                                    <input class="btn btn-danger fs-4 w-75 fw-light w-75 me-1" style="letter-spacing: 1px;" type="text" value="Latency tolerance below the current latency." readonly>
                                    <input class="btn btn-danger fs-4 w-25" type="text" :value="String(probe.latency_tolerance) + ' ms'" readonly>
                                </div>
                            </div>
                            <div v-if="viewHops && test_results.hops != null" class="mt-2">
                                <div class="btn fw-light w-100 rounded" style="overflow-y: auto; height: 320px; border: solid 0px rgb(0, 54, 73);">
                                    <div class="flex-nowrap rounded">
                                        <div class="btn bg-synapse-glass fw-light fs-3 mt-2 w-100" style="cursor: default;" v-for="(h, i) in test_results.hops" v-bind:key="i+1">
                                            <span class="fs-3 text-white">Hop: {{h.hop}}</span>
                                            <div v-if="h.branchs.length > 0">
                                                <div class="input-group flex-nowrap w-100 mt-2 p-1" v-for="(branch, ib) in h.branchs" v-bind:key="ib+1">
                                                    <button class="btn btn-synapse w-25">
                                                        <i class="fa-solid fa-network-wired"></i>
                                                    </button>
                                                    <input class="btn btn-synapse-dark w-50 fw-light" style="cursor: text;" :value="branch.ip" readonly>
                                                    <button class="btn btn-synapse w-25">
                                                        <i class="fa-solid fa-clock"></i>
                                                    </button>
                                                    <button class="btn btn-synapse-dark w-50 fs-6" style="cursor: text;">
                                                        <span class="fw-light">{{branch.time}} ms</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div v-if="h.branchs.length == 0">
                                                <button class="btn btn-synapse-dark w-100">
                                                    Unknown hops.
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-group flex-nowrap mt-2">
                                        <button class="btn btn-synapse w-25">
                                            <i class="fa-solid fa-network-wired me-2"></i>
                                            <span class="fw-bold">Destination</span>
                                        </button>
                                        <input class="btn btn-synapse-dark fs-4 w-75" type="text" style="cursor: text;" :value="test_results.endpoint_ip" readonly>
                                        <button class="btn w-25 fs-4" :class="{'btn-synapse': test_results.connectivity, 'btn-danger': !test_results.connectivity}"
                                        :title="`Reached destination: ${test_results.connectivity}`">
                                            <i class="fa-solid" :class="{'fa-road-circle-check': test_results.connectivity, 'fa-road-circle-xmark': !test_results.connectivity }"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Upload -->
                            <div class="row mt-2">
                                <div class="col-md-12">
                                    <div v-if="!test_results.error">
                                        <button class="btn btn-synapse fs-2 w-100" title="Upload" @click="addProbe" :disabled="addingProbe">
                                            <i class="fa-solid" :class="{'fa-cloud-arrow-up': !addingProbe, 'fa-refresh fa-spin': addingProbe}"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- New Credential Section -->
        <div class="modal fade" id="new-credential" tabindex="-1">
            <div class="modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content bg-black border-synapse-dark">
                    <!-- Header -->
                    <div class="modal-header border-0">
                        <div class="input-group flex-nowrap w-100">
                            <button class="btn bg-black text-white text-start fs-2" style="width: 90%; letter-spacing: 4px; cursor: default;">New Credential</button>
                            <button class="btn btn-danger rounded" title="Close probe results." data-bs-dismiss="modal" style="width: 10%;">
                                <i class="fa-solid fa-2xl fa-close"></i>
                            </button>
                        </div>
                    </div>
                    <!-- Body -->
                    <div class="modal-body bg-black">
                        <div :class="{'disabled-div': addingCredential}">
                            <div class="input-group-flex-nowrap">
                                <button class="btn btn-synapse-dark fs-2 w-25" tabindex="-1">
                                    <i class="fa-solid fa-id-badge me-2"></i>
                                    <i class="fa-solid fa-n"></i>
                                </button>
                                <input type="text" class="btn bg-synapse-glass text-white fs-2 w-75" placeholder="Credential Name" style="cursor: text;" v-model="new_credential.name">
                            </div>
                            <div class="input-group-flex-nowrap mt-2">
                                <button class="btn btn-synapse-dark fs-2 w-25" tabindex="-1">
                                    <i class="fa-solid fa-id-badge me-2"></i>
                                    <i class="fa-solid fa-a"></i>
                                </button>
                                <input type="text" class="btn bg-synapse-glass text-white fs-2 w-75" placeholder="Credential Alias" style="cursor: text;" v-model="new_credential.alias">
                            </div>
                            <div class="input-group-flex-nowrap mt-2">
                                <button class="btn btn-synapse-dark fs-2 w-25" tabindex="-1">
                                    <i class="fa-solid fa-user"></i>
                                </button>
                                <input type="text" class="btn bg-synapse-glass text-white fs-2 w-75" placeholder="Username" style="cursor: text;" v-model="new_credential.username">
                            </div>
                            <div class="input-group-flex-nowrap mt-2">
                                <form class="w-100">
                                    <button type="button" class="btn btn-synapse-dark fs-2 w-25" tabindex="-1">
                                        <i class="fa-solid fa-key"></i>
                                    </button>
                                    <input type="password" class="btn bg-synapse-glass text-white fs-2 w-75" placeholder="Password" style="cursor: text;" v-model="new_credential.password">
                                </form>
                            </div>
                            <div class="input-group-flex-nowrap mt-2">
                                <button class="btn btn-synapse-dark fs-2 w-25" tabindex="-1">
                                    <i class="fa-solid fa-cube"></i>
                                </button>
                                <select class="btn bg-synapse-glass text-white fs-2 w-75" v-model="new_credential.type">
                                    <option :value="null">Select a type...</option>
                                    <option value="url">URL</option>
                                    <option value="databank">Databank</option>
                                </select>
                            </div>
                            <div class="input-group-flex-nowrap mt-2">
                                <button class="btn btn-synapse fs-2 w-100" @click="addCredential" :disabled="addingCredential">
                                    <i class="fa-solid" :class="{'fa-plus': !addingCredential, 'fa-refresh fa-spin': addingCredential}"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Notificators Section -->
        <div class="modal fade" id="manage-notificators" tabindex="-1">
            <div class="modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content bg-black border-synapse-dark" style="height: 500px;">
                    <!-- Header -->
                    <div class="modal-header border-0">
                        <div class="input-group flex-nowrap w-100">
                            <button class="btn bg-black text-white text-start fs-2" style="width: 90%; letter-spacing: 4px; cursor: default;">Notificators</button>
                            <!-- Power Off/On Notificators -->
                            <button v-if="mode=='addition' && false" class="btn rounded me-2" :class="{'btn-synapse-dark': nprobe.exec_notificators, 'btn-dark': !nprobe.exec_notificators}" title="Power Off/On notificators." style="width: 10%;" @click="nprobe.exec_notificators = !nprobe.exec_notificators">
                                <i class="fa-solid fa-2xl fa-power-off"></i>
                            </button>
                            <button v-if="mode=='edition' && false" class="btn rounded me-2" :class="{'btn-synapse-dark': eprobe.exec_notificators, 'btn-dark': !eprobe.exec_notificators}" title="Power Off/On notificators." style="width: 10%;" @click="eprobe.exec_notificators = !eprobe.exec_notificators">
                                <i class="fa-solid fa-2xl fa-power-off"></i>
                            </button>
                            <!-- Refresh Notificators -->
                            <button v-if="mode=='addition'" class="btn btn-synapse-dark rounded me-2" title="Refresh notificators." style="width: 10%;" @click="getNotificators" :disabled="gettingNotificators">
                                <i class="fa-solid fa-2xl fa-refresh" :class="{'fa-spin': gettingNotificators}"></i>
                            </button>
                            <button v-if="mode=='edition'" class="btn btn-synapse-dark rounded me-2" title="Refresh probe notificators." style="width: 10%;" @click="getProbeNotificators" :disabled="gettingNotificators">
                                <i class="fa-solid fa-2xl fa-refresh" :class="{'fa-spin': gettingNotificators}"></i>
                            </button>
                            <button class="btn btn-danger rounded" title="Close probe notificators." data-bs-dismiss="modal" style="width: 10%;">
                                <i class="fa-solid fa-2xl fa-close"></i>
                            </button>
                        </div>
                    </div>
                    <!-- Body -->
                    <div class="modal-body bg-black" style="overflow: hidden;">
                        <div>
                            <div class="input-group-flex-nowrap">
                                <button class="btn border-bottom-synapse border-top-synapse text-white fs-5 me-1 text-white" style="width: 7%;">
                                    <i class="fa-solid fa-power-off"></i>
                                </button>
                                <input type="text" class="btn border-bottom-synapse border-top-synapse text-white fs-5 me-1" value="Name" style="width: 30%;">
                                <input type="text" class="btn border-bottom-synapse border-top-synapse text-white fs-5 me-1" value="Alias" style="width: 30%;">
                                <input type="text" class="btn border-bottom-synapse border-top-synapse text-white fs-5 me-1" value="Type" style="width: 30%;">
                            </div>
                        </div>
                        <div class="" style="height: 340px; overflow-y: scroll;">
                            <div class="input-group-flex-nowrap mt-3" v-for="(n,ni) in notificators" :key="`nio${ni}`">
                                <button class="btn bg-gradient fs-5 me-1" :class="{'btn-synapse-dark': n.include, 'btn-dark': !n.include}" style="width: 7%;" @click="n.include = !n.include">
                                    <i class="fa-solid" :class="{'fa-bell': n.include , 'fa-bell-slash': !n.include}"></i>
                                </button>
                                <input type="text" class="btn fs-5 me-1" :class="{'btn-synapse-dark': n.include, 'btn-dark': !n.include}" style="width: 30%;" :value="n.name" readonly>
                                <input type="text" class="btn text-white fs-5 me-1" :class="{'btn-synapse-dark': n.include, 'btn-dark': !n.include}" style="width: 30%;" :value="n.alias" readonly>
                                <input type="text" class="btn text-white fs-5 me-1" :class="{'btn-synapse-dark': n.include, 'btn-dark': !n.include}" style="width: 30%;" :value="translator[n.type]" readonly>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>




  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

// Add this to parent headerbar: @setAppSection="setAppSection($event)"

import axios from "axios";

export default {
  name: 'Devices',
  components: {},
  data(){
    return {
      // General
        site: null,
        stage: null,
        mode: "default",
      // Probes
        gettingProbes: false,
        probes: [],
        probe: {},
        poweringProbe: false,
      // Addition
        blockProbe: false,
        addPermission: false,
        validatingProbe: false,
        addingProbe: false,
        resolvedIPS: [],
        resolving: false,
        nprobe: {
            name: null,
            alias: null,
            type: null,
            category: null,
            active: true,
            exec_notificators: false
        },
        dnprobe: {
            name: null,
            alias: null,
            type: null,
            category: null,
            active: true,
            exec_notificators: false
        },
        // URL
        nurl:{
            endpoint: null,
            method: null,
            credentials: null,
            args: [],
            timeout: 15,
            exec_latency_tolerance: false,
            latency_tolerance: null,
            exec_status_code_tolerance: false,
            status_code_tolerance: [],
            codes_whitelist: true,
            exec_similarity_tolerance: false,
            similarity_tolerance: null
        },
        dnurl:{
            endpoint: null,
            method: null,
            credentials: null,
            args: [],
            timeout: 15,
            exec_latency_tolerance: false,
            latency_tolerance: null,
            exec_status_code_tolerance: false,
            status_code_tolerance: [],
            codes_whitelist: true,
            exec_similarity_tolerance: false,
            similarity_tolerance: null
        },
        // Databanks
        ndb: {
            server: null,
            schema: null,
            table: null,
            timeout: 15,
            credentials: null,
            exec_action: false,
            action: null,
            exec_latency_tolerance: true, 
            latency_tolerance: null,
            exec_connection_latency_tolerance: false, 
            connection_latency_tolerance: null,
            exec_action_latency_tolerance: false, 
            action_latency_tolerance: null,
            exec_similarity_tolerance: false, 
            similarity_tolerance: null
        },
        dndb: {
            server: null,
            schema: null,
            table: null,
            timeout: 15,
            credentials: null,
            exec_action: false,
            action: null,
            exec_latency_tolerance: true, 
            latency_tolerance: null,
            exec_connection_latency_tolerance: false, 
            connection_latency_tolerance: null,
            exec_action_latency_tolerance: false, 
            action_latency_tolerance: null,
            exec_similarity_tolerance: false, 
            similarity_tolerance: null
        },
        // Pings
        nping: {
            endpoint: null,
            repeats: 10,
            exec_latency_tolerance: true, 
            latency_tolerance: null
        },
        dnping: {
            endpoint: null,
            repeats: 10,
            exec_latency_tolerance: true, 
            latency_tolerance: null
        },
        // Traceroute
        ntrace: {
            endpoint: null,
            endpoint_ip: null,
            max_hops: 10,
            timeout: 30,
            exec_connectivity: false,
            exec_trace_length: false,
            exec_hops_change: false,
            hops_change_tolerance: 0
        },
        dntrace: {
            endpoint: null,
            endpoint_ip: null,
            max_hops: 10,
            timeout: 30,
            exec_connectivity: false,
            exec_trace_length: false,
            exec_hops_change: false,
            hops_change_tolerance: 0
        },
        nstatuscode: null,
        narguments: [],
        args_limit: 9,
        argname: null,
        argvalue: null,
        argcounter: 0,
        categories: {
            url : [
                { name: 'html', alias: 'HTML' },
                { name: 'json', alias: 'JSON' }
            ],
            databank : [
                { name: 'mysql', alias: 'MySQL' }
            ],
            ping : [
                { name: 'icmp', alias: 'Ping ICMP' }
            ],
            traceroute : [
                { name: 'standard', alias: 'Standard'}
            ]
        },
        gettingCredentials: false,
        selected_credential: null,
        credentials: [],
      // Notificators
        gettingNotificators: false,
        notificators: [],
        translator:{
            ms_teams: 'Microsoft Teams',
            snmp_trap: 'SNMP Trap',
            e_mail: 'E-Mail'
        },

      // Testing
        test_results: null,
        viewHops: false,
      // Delete
        deletingProbe: false,
      // Edition
        eprobe: {
            type: null
        },
        deprobe: {
            type: null
        },
      // Edit
        savingProbe: false,
      // New credential
        addingCredential: false,
        new_credential: { name: null, alias: null, username: null, password: null, type: null},
        dnew_credential: { name: null, alias: null, username: null, password: null, type: null},

      // Filtering
        searchWord: "",
        searchType: "alias",
        searchType_ind: "alias"
    }
  },
  methods:{
    // Probes
    getProbes(){
        this.gettingProbes = true
        const params = {}
        const dest = this.site + '/synapse/probes/getProbes' 
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.probes = rx.data.probes
                this.gettingProbes = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingProbes = false
        });
    },
    getCredentials(){
        this.gettingCredentials = true
        const params = {}
        const dest = this.site + '/synapse/probes/getCredentials' 
        axios
            .get(dest, {})
            .then(rx => {
                // OK
                this.credentials = rx.data.credentials
                this.gettingCredentials = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingCredentials = false
        });
    },

    // Delete
    deleteProbe(_probe, _index){
        if (!confirm(`Delete probe ${_probe.name}?`)){
            return
        }
        this.deletingProbe = true
        // Send request.
        const dest = this.site + '/synapse/probes/deleteProbe' 
        axios
            .post(dest, _probe)
            .then(rx => {
                // OK
                this.deletingProbe = false
                var idx = this.probes.indexOf(_probe)
                this.probes.splice(idx, 1)
                alert(rx.data.message)
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.deletingProbe = false
        });
    },

    // Addition
    validateProbe(){
        var btn = document.getElementById('trbutton')
        this.blockProbe = true
        this.validatingProbe = true
        if (this.nprobe.type == 'url'){
            this.nurl.args = this.cloneObject(this.narguments)
            this.probe = Object.assign({}, this.nprobe, this.nurl);
        }
        else if (this.nprobe.type == 'databank'){
            this.ndb.args = this.cloneObject(this.narguments)
            this.probe = Object.assign({}, this.nprobe, this.ndb);
        }
        else if (this.nprobe.type == 'ping'){
            this.probe = Object.assign({}, this.nprobe, this.nping);
        }
        else if (this.nprobe.type == 'traceroute'){
            this.viewHops = false
            this.probe = Object.assign({}, this.nprobe, this.ntrace);
        }
        // Send request.
        const dest = this.site + '/synapse/probes/validateProbe' 
        axios
            .post(dest, this.probe)
            .then(rx => {
                // OK
                this.validatingProbe = false
                this.blockProbe = false
                this.test_results = rx.data.results
                btn.click()
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.blockProbe = false
                this.validatingProbe = false
        });
    },
    addProbe(){
        var btn = document.getElementById('trbutton')
        this.addingProbe = true
        if (this.nprobe.type == 'url'){
            this.nurl.args = this.cloneObject(this.narguments)
            this.probe = Object.assign({}, this.nprobe, this.nurl);
        }
        else if (this.nprobe.type == 'databank'){
            this.ndb.args = this.cloneObject(this.narguments)
            this.probe = Object.assign({}, this.nprobe, this.ndb);
        }
        // Ping doesn't need fusion because doesn't have arguments.
        else if (this.nprobe.type == 'ping'){}
        // Traceroute doesn't need fusion because doesn't have arguments.
        else if (this.nprobe.type == 'traceroute'){
            this.probe.endpoint_ip = this.test_results.endpoint_ip
        }
        // Add notificators.
        this.probe.notificators = this.cloneObject(this.notificators)
        // Send request.
        const dest = this.site + '/synapse/probes/addProbe' 
        axios
            .post(dest, this.probe)
            .then(rx => {
                // OK
                alert(rx.data.message)
                this.addingProbe = false
                this.clearAddition(null)
                btn.click()
                this.getProbes()
                this.getNotificators()
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.addingProbe = false
        });
    },
    addArgument(){
        if (this.argvalue == null || this.argvalue == ""){
            alert('Empty parameter value.')
            return
        } 
        // Check the max limit.
        if (this.narguments.length >= this.args_limit){
            alert('Parameters limit reached.')
            return
        }
        // Check the type.
        if (this.nprobe.type == 'url' || this.eprobe.type == 'url'){
            if (this.argname == null || this.argname == ""){
                alert('Empty parameter name.')
                return
            } 
            this.narguments.push([this.argname, this.argvalue])
        }
        else if (this.nprobe.type == 'databank' || this.eprobe.type == 'databank'){
            this.narguments.push(this.argvalue)
        }
        this.argname = null
        this.argvalue = null
    },
    removeArgument(idx){
        this.narguments.splice(idx, 1);
    },
    // Add Probe
    setAddition(){
        this.mode = 'addition'
        this.clearAddition(null)
        this.getCredentials()
        this.getNotificators()
    },
    clearAddition(probe_type){
        this.probe = {}
        this.nprobe = this.cloneObject(this.dnprobe)
        this.nprobe.type = probe_type
        this.nurl = this.cloneObject(this.dnurl)
        this.ndb = this.cloneObject(this.dndb)
        this.nping = this.cloneObject(this.dnping)
        this.ntrace = this.cloneObject(this.dntrace)
        this.blockProbe = false
        this.addPermission = false
        this.narguments = []
        this.validatingProbe = false
        this.viewHops = false
    },
    closeAddition(){
        this.mode = 'default'
    },

    // Edition
    saveProbe(){
        // Notificators
        this.eprobe.notificators = this.cloneObject(this.notificators)
        // Send request.
        this.savingProbe = true
        const dest = this.site + '/synapse/probes/saveProbe' 
        axios
            .post(dest, this.eprobe)
            .then(rx => {
                // OK
                alert(rx.data.message)
                this.savingProbe = false
                this.getProbes()
                this.closeEdition()
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.savingProbe = false
        });
    },
    setEdition(_probe){
        this.eprobe = _probe
        this.narguments = _probe.args
        this.getProbeNotificators()
        this.mode = 'edition'
    },
    closeEdition(){
        this.mode = 'default'
        this.clearEdition()
    },
    clearEdition(){
        this.eprobe = this.cloneObject(this.deprobe)
        this.narguments = []
        this.argname = null
        this.argvalue = null
        this.nstatuscode = null
        this.notificators = []
    },
    powerProbe(_probe, _index){
        // Send request.
        this.poweringProbe = true
        const dest = this.site + '/synapse/probes/powerProbe' 
        axios
            .post(dest, _probe)
            .then(rx => {
                // OK
                this.probes[_probe.original_index].active = !this.probes[_probe.original_index].active
                //this.getProbes()
                this.poweringProbe = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.poweringProbe = false
        });
    },

    // Credentials
    addCredential(){
        this.addingCredential = true
        // Send request.
        const dest = this.site + '/synapse/probes/addCredential' 
        axios
            .post(dest, this.new_credential)
            .then(rx => {
                // OK
                alert(rx.data.message)
                this.addingCredential = false
                this.clearCredential()
                this.getCredentials()
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.addingCredential = false
        });
    },
    clearCredential(){
        this.new_credential = this.cloneObject(this.dnew_credential)
    },
    // Domain resolver.
    resolveEndpoint(_domain){
        this.resolving = true
        const params = {domain: _domain}
        const dest = this.site + '/synapse/probes/resolveDomain' 
        axios
            .get(dest, {params})
            .then(rx => {
                this.resolvedIPS = rx.data.ips
                if (this.resolvedIPS.length == 0){
                    this.resolvedIPS = [ _domain ]
                }
                this.resolving = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.resolving = false
        });
    },
    // Notificators
    getNotificators(){
        this.notificators = []
        this.gettingNotificators = true
        const params = {}
        const dest = this.site + '/synapse/probes/getNotificators' 
        axios
            .get(dest, {})
            .then(rx => {
                // OK
                this.notificators = rx.data.notificators
                this.gettingNotificators = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingNotificators = false
        });
    },
    getProbeNotificators(){
        this.notificators = []
        this.gettingNotificators = true
        const params = {}
        const dest = this.site + '/synapse/probes/getProbeNotificators'
        axios
            .post(dest, this.eprobe)
            .then(rx => {
                // OK
                this.notificators = rx.data.notificators
                this.gettingNotificators = false
            })
            .catch(error => {
                this.processErrorMessage(error.response.data)
                this.gettingNotificators = false
        });
    },

    // Filtering
    setSearchType(search_type){
      this.searchType = search_type
      if (search_type == 'name' || search_type == 'alias'){
          this.searchType_ind = search_type
      }
    },

    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = error.error
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    printObject(_object){
        console.log(JSON.stringify(_object, null, "   "))
    },
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.getProbes()
    this.getCredentials()
  },
  computed: {
    filteredProbes(){
        if (this.searchWord == ''){
            return this.probes
        }
        this.searchWord = this.searchWord.toLowerCase()
        return this.probes.filter( probe => String(probe[this.searchType]).toLowerCase().includes( this.searchWord ) );
    }
  }
}
</script>

<style scoped>

    .border-synapse{
        border: solid 1px rgb(108, 194, 225);
    }
    .border-synapse-dark{
        border: solid 1px rgb(0, 54, 73);
    }

    .border-top-synapse{
        border-top: solid 2px rgb(0, 81, 125);
    }
    .border-bottom-synapse{
        border-bottom: solid 2px rgb(0, 81, 125);
    }
        

    /* BTN-Synapse */
    .btn-synapse{
        background-color: rgb(108, 194, 225);
        color: Black;
        box-shadow: 0px 0px 8px 0px rgb(249, 249, 249);
        transition-duration: 0.5s;
    }
    .btn-synapse:hover{
        box-shadow: 0px 0px 25px 0px rgb(249, 249, 249);
        color: White;
    }

    .btn-synapse-dark{
        background-color: rgb(0, 54, 73);
        color: White;
        box-shadow: 0px 0px 8px 0px rgb(0, 81, 125);
        transition-duration: 0.5s;
    }
    .btn-synapse-dark:hover{
        box-shadow: 0px 0px 25px 0px rgb(0, 81, 125);
        color: rgb(52, 143, 186);
    }

    .bg-synapse-glass{
        box-shadow: inset 0 0 2000px rgba(13, 80, 106, 0.447);
    }
    .bg-glass{
        box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.216);
    }
    .bg-light-glass{
        box-shadow: inset 0 0 1000px rgba(50, 248, 255, 0.108);
    }

    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 20px;
        cursor: pointer;
        box-shadow: 0px 0px 0px #000000;
        background: rgb(0, 54, 73);
        border-radius: 15px;
        border: 0px solid #000101;
    }
    input[type=range]::-webkit-slider-thumb {
        box-shadow: 0px 0px 0px #000000;
        border: 1px solid #000000;
        height: 30px;
        width: 40px;
        border-radius: 40px;
        background: rgb(108, 194, 225);
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -3.5px;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

  /* Table with static header */
  .tableFixHead {
      overflow-y: auto;
      overflow-x: hidden;
    }
  .tableFixHead thead th {
      position: sticky;
      top: -5px;
      text-align: center;
      z-index: 1;
  }
  table {
      border-collapse: collapse;
      width: 100%;
  }
  th, td {
      padding: 4px 16px;
  }
  th {
      background: #eee;
  }

</style>
